<div class="chapter-form-component">
    <h6 class="form-label profile-form-label" style="font-weight:bolder; font-size: 25px;">{{ getFormTitle() }}</h6>

    <form [formGroup]="chapterForm" (ngSubmit)="onSubmit()" class="chapterForm">
        <div class="row mb-3 mt-1">
            <div class="col-3">
                <label class="form-label">Title <span class="text-danger">*</span></label>
                <input type="text" class="form-control" formControlName="Title" placeholder="Enter Chapter Title" [ngClass]="{'disabled form-control-disabled': applyDisableStyle('Title')}"/>
                <small class="text-danger"
                    *ngIf="chapterForm.get('Title')?.invalid && chapterForm.get('Title')?.touched">
                    Title is required (min 3 characters).
                </small>
            </div>
            <div class="col-3">
                <div>
                    <label for="type" class="form-label">
                        {{ finalResources.chapterTypeLabel }} <span class="text-danger">*</span>
                    </label>
                    <select id="type" formControlName="Type" class="form-control"
                        [ngClass]="{'disabled-class': !isAddMode}" [ngClass]="{'disabled form-control-disabled': applyDisableStyle('Type')}">
                        <option value="" disabled selected>{{finalResources.chapterTypePlaceHolder}}</option>
                        <option *ngFor="let lang of chapterTypeOptions" [value]="lang.textValue">
                            {{ lang.textValue }}
                        </option>
                    </select>
                </div>
            </div>
        </div>

        <div class="row mb-2">
            <div class="mb-2 col-6">
                <label class="form-label">Description</label>
                <textarea class="form-control description-control" formControlName="Description"
                    placeholder="Enter Description" [ngClass]="{'disabled form-control-disabled': applyDisableStyle('Description')}"></textarea>
            </div>

            <div class="col-3">
                <div class="row mb-2">
                    <div class="col-12">
                        <label class="form-label">Group Name</label>
                        <input type="text" class="form-control" formControlName="GroupName"
                            placeholder="Enter Group Name" [ngClass]="{'disabled form-control-disabled': applyDisableStyle('GroupName')}"/>

                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <label class="form-label">Access Rights</label>
                        <div class="custom-select-dropdown" #accessRightsWrapper>
                            <button type="button" class="form-control custom-select-toggle"
                                (click)="toggleAccessRightsDropdown($event)"
                                [title]="finalResources.chapterRightPlaceHolder"
                                [ngClass]="{'disabled form-control-disabled': applyDisableStyle('AccessRights')}">
                                <span class="selected-label">
                                    {{ getSelectedAccessRightsLabel() || finalResources.chapterRightPlaceHolder ||
                                    `Select
                                    Access Rights` }}
                                </span>
                            </button>
                            <div class="custom-select-menu" *ngIf="accessRightsDropdownOpen">
                                <label class="custom-select-option" *ngFor="let right of availableAccessRights">
                                    <input type="checkbox" [checked]="isRightSelected(right)"
                                        (change)="onAccessRightToggle($event, right)"/>
                                    <span>{{ right }}</span>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <div class="row mb-2">
            <!-- Upload Audio -->
            <div class="col-6 relative" style="position: relative;">
                <div class="w-full max-w-md mx-auto">
                    <div class="custom-file-upload-container audio-upload-container">
                        <label for="audio-upload" class="w-full block audio-upload-label" [ngClass]="{'disabled form-control-disabled': applyDisableStyle('AudioFile')}">
                            <div class="d-flex align-items-center justify-content-center gap-1 opacity-50">
                                <span class="bi bi-cloud-arrow-up" style="font-size: 1.5rem; margin: 0 8px;"></span>
                                Upload Song Recording
                            </div>
                        </label>
                        <input id="audio-upload" type="file" style="display: none;" multiple
                            (change)="onFileSelected($event, 'Audio')" accept=".mp3,.wav">

                        <div *ngIf="audioItems.length" class="audio-list">
                            <div *ngFor="let item of audioItems; let i = index" class="audio-list-item"
                                [class.dragging]="draggedAudioIndex === i" [class.drag-over]="dragOverAudioIndex === i"
                                [attr.draggable]="dragEnabledIndex === i ? 'true' : 'false'"
                                (dragstart)="onAudioDragStart($event, i)" (dragover)="onAudioDragOver($event, i)"
                                (dragleave)="onAudioDragLeave()" (drop)="onAudioDrop($event, i)"
                                (dragend)="onAudioDragEnd()">
                                <span class="audio-grip-handle" title="Drag to reorder"
                                    (mousedown)="onAudioHandleMouseDown(i)" (mouseup)="onAudioHandleMouseUp()"
                                    [ngClass]="{'disabled form-control-disabled': applyDisableStyle('AudioFile')}">⋮⋮</span>
                                <div class="audio-item-body">
                                    <span class="audio-file-name">{{ getAudioFileName(item.url) }}</span>
                                    <audio #audioPlayer *ngIf="item.blobUrl" [src]="item.blobUrl" controls
                                        style="height: 38px;" (play)="onAudioPlay(audioPlayer)"></audio>
                                </div>
                                <button type="button" class="btn btn-sm btn-outline-danger" (click)="removeAudioItem(i)"
                                    title="Remove Audio File" [ngClass]="{'disabled form-control-disabled': applyDisableStyle('AudioFile')}">✕</button>
                            </div>
                        </div>
                    </div>
                </div>
                <small *ngIf="audioError" class="text-danger">{{ audioError }}</small>
            </div>

            <!-- Upload Thumbnail Image -->
            <div class="col-3">
                <div class="custom-file-upload-container thumbnail-upload-container position-relative"  [ngClass]="{'disabled form-control-disabled': applyDisableStyle('ThumbnailImage')}">
                    <label for="thumbnail-upload" class="w-full block thumbnail-upload-label" style="cursor: pointer;">
                        <div class="d-flex align-items-center justify-content-center gap-1 opacity-50">
                            <span class="bi bi-cloud-arrow-up" style="font-size: 1.5rem; margin: 0 8px;"></span>
                            Upload Thumbnail Image
                        </div>
                    </label>

                    <input id="thumbnail-upload" type="file" style="display: none;"
                        (change)="onFileSelected($event, 'ThumbnailImage')" accept=".jpeg,.jpg,.png">

                    <div *ngIf="imagePreviewUrl" class="thumbnail-preview-body">
                        <img [src]="imagePreviewUrl" alt="Thumbnail Preview">
                        <button type="button" class="btn btn-sm btn-outline-danger remove-thumbnail-btn"
                            title="Remove Thumbnail Image" (click)="removeThumbnail()">✕</button>
                        <p *ngIf="thumbnailFileName" class="thumbnail-file-name">{{ thumbnailFileName }}</p>
                    </div>
                </div>
                <small *ngIf="imageError" class="text-danger">{{ imageError }}</small>
            </div>

            <!-- Upload Chapter Icon -->
            <div class="col-3">
                <div class="custom-file-upload-container thumbnail-upload-container position-relative"  [ngClass]="{'disabled form-control-disabled': applyDisableStyle('ChapterIcon')}">
                    <label for="chapter-icon-upload" class="w-full block thumbnail-upload-label" style="cursor: pointer;">
                        <div class="d-flex align-items-center justify-content-center gap-1 opacity-50">
                            <span class="bi bi-cloud-arrow-up" style="font-size: 1.5rem; margin: 0 8px;"></span>
                            Upload Chapter Icon
                        </div>
                    </label>

                    <input id="chapter-icon-upload" type="file" style="display: none;"
                        (change)="onFileSelected($event, 'ChapterIcon')" accept=".jpeg,.jpg,.png">

                    <div *ngIf="chapterIconPreviewUrl" class="thumbnail-preview-body">
                        <img [src]="chapterIconPreviewUrl" alt="Thumbnail Preview">
                        <button type="button" class="btn btn-sm btn-outline-danger remove-thumbnail-btn"
                            title="Remove Chapter Icon" (click)="removeChapterIcon()">✕</button>
                        <p *ngIf="chapterIconFileName" class="thumbnail-file-name">{{ chapterIconFileName }}</p>
                    </div>
                </div>
                <small *ngIf="imageError" class="text-danger">{{ imageError }}</small>
            </div>
        </div>

        <div class="row mb-2 mt-4">
            <div class="col-3">
                <label class="form-label">Status <span class="text-danger">*</span></label>
                <select id="type" formControlName="Status" class="form-control"
                    [title]="finalResources.chapterStatusPlaceHolder">
                    <option disabled selected>{{finalResources.chapterStatusPlaceHolder}}</option>
                    <option *ngFor="let lang of chapterStatusOptions" [value]="lang.textValue">
                        {{ lang.textValue }}
                    </option>
                </select>
            </div>
            <div class="col-8">
                <div class="form-label" style="visibility: hidden;">-</div>
                <button type="submit" class="btn saveBtn" [disabled]="!isFormChanged || !chapterForm.valid">{{
                    isAddMode?
                    finalResources.addBtnTitle : finalResources.updateBtnTitle}}</button>
                <button type="button" class="btn cancelBtn" (click)="OnCancelBtnClick()">Cancel</button>
            </div>
        </div>
    </form>
</div>